import { default as moment } from 'moment';
import TokenSession from "./session/TokenSession";
import StringUtil from "./StringUtil";

interface IEventData {
	title: string;
	description?: string;
	url?: string;
	start: Date;
	end: Date;
}

export default class CalendarUtil {

	public static downloadICS({start, end, title, description, url}: IEventData) {

		const format = 'YYYYMMDD[T]HHmmss';

		window.open('data:text/calendar;charset=utf8,' + encodeURIComponent(
			[
				'BEGIN:VCALENDAR',
				'VERSION:2.0',
				'CALSCALE:GREGORIAN',
				'PRODID:' + TokenSession.getContext().name,
				'METHOD:PUBLISH',
				'X-PUBLISHED-TTL:PT1H',
				'BEGIN:VEVENT',
				'UID:' + StringUtil.generateUuid(),
				'SUMMARY:' + title,
				'DTSTAMP:' + moment().format(format),
				'DTSTART:' + moment(start).format(format),
				'DTEND:' + moment(end || start).format(format),
				'DESCRIPTION:' + (description || ''),
				'URL:' + (url || ''),
				'STATUS:CONFIRMED',
				'END:VEVENT',
				'END:VCALENDAR'
			].join('\r\n')
		));
	}

}



// WEBPACK FOOTER //
// ./src/core/util/CalendarUtil.ts